import React from "react";
import { Link } from "react-router-dom";

export const PrivacyPolicy = () => {
  return (
    <div className="bg-ink text-bone min-h-screen pt-32 pb-20 px-5 md:px-14 lg:px-20 font-serif">
      <div className="max-w-3xl mx-auto space-y-12">
        <header className="space-y-4 border-b border-bone/10 pb-8">
          <p className="label text-stone tracking-[0.25em] text-xs uppercase">Data Protection</p>
          <h1 className="text-4xl md:text-5xl font-light text-bone">Privacy Policy</h1>
        </header>

        <section className="space-y-8 text-stone font-sans text-sm leading-relaxed font-light">
          <div>
            <h2 className="text-bone font-serif text-lg mb-2">1. Data Controller</h2>
            <p>
              The Data Controller for personal data collected through this website is <strong className="text-bone">PS3D CREATIVE di Sampaolesi Pierpaolo</strong>, with registered office at Largo Monte Cardosa 4, 62019 Recanati (MC), Italy. For any privacy-related inquiries, you may contact us at <a href="mailto:info@alkeontimelessdesign.com" className="text-bone underline underline-offset-4 hover:text-sand transition-colors">info@alkeontimelessdesign.com</a>.
            </p>
          </div>

          <div>
            <h2 className="text-bone font-serif text-lg mb-2">2. Categories of Personal Data Collected</h2>
            <p>We process personal data provided directly by users or collected automatically during navigation:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li><strong>Identification & Contact Data:</strong> Name, email address, shipping address, and phone number provided during account creation, checkout, or newsletter subscription.</li>
              <li><strong>Transaction Data:</strong> Details regarding orders and purchases (payment confirmation is handled securely via Stripe; we do not store full credit card details on our servers).</li>
              <li><strong>Technical & Navigation Data:</strong> Standard server logs, IP addresses, and browser data collected automatically for website operation and security via our hosting provider.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-bone font-serif text-lg mb-2">3. Purposes & Legal Bases of Processing</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Contractual Performance:</strong> Processing orders, managing shipments, customer support, and returns (Legal basis: Execution of a contract pursuant to Art. 6(1)(b) GDPR).</li>
              <li><strong>Legal Obligations:</strong> Compliance with tax, accounting, and administrative requirements under Italian and EU law (Legal basis: Compliance with a legal obligation pursuant to Art. 6(1)(c) GDPR).</li>
              <li><strong>Consent (Newsletter & Communications):</strong> Sending atelier updates and announcements upon explicit subscription (Legal basis: Consent pursuant to Art. 6(1)(a) GDPR).</li>
            </ul>
          </div>

          <div>
            <h2 className="text-bone font-serif text-lg mb-2">4. Data Retention</h2>
            <p>
              Personal data related to orders and invoicing are retained for the statutory period required by Italian tax and civil law (typically 10 years). Newsletter subscription data is retained until the user unsubscribes or requests deletion. Inquiry data is kept for the time strictly necessary to fulfill the request.
            </p>
          </div>

          <div>
            <h2 className="text-bone font-serif text-lg mb-2">5. Data Recipients & Service Providers</h2>
            <p>
              To operate our e-commerce and fulfill our services, data may be shared with trusted third-party providers acting as data processors:
            </p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li><strong>Hosting Provider:</strong> Register.it (website infrastructure and secure hosting).</li>
              <li><strong>Payment Gateway:</strong> Stripe, Inc. (secure online payment processing).</li>
              <li><strong>Shipping Partners:</strong> Couriers and logistics services responsible for delivering orders.</li>
            </ul>
          </div>

          <div>
            <h2 className="text-bone font-serif text-lg mb-2">6. International Data Transfers</h2>
            <p>
              Where technical service providers (such as payment processors or cloud infrastructure) process data outside the European Economic Area (EEA), such transfers are governed by appropriate safeguards, such as European Commission Standard Contractual Clauses (SCCs) or adequacy decisions.
            </p>
          </div>

          <div>
            <h2 className="text-bone font-serif text-lg mb-2">7. Data Subject Rights</h2>
            <p>
              Under the GDPR (Articles 15–22), users have the right to access, rectify, erase, restrict, or object to the processing of their data, as well as the right to data portability. Requests can be sent to <a href="mailto:info@alkeontimelessdesign.com" className="text-bone underline underline-offset-4 hover:text-sand transition-colors">info@alkeontimelessdesign.com</a>. Users also have the right to lodge a complaint with the Italian Data Protection Authority (Garante per la protezione dei dati personali).
            </p>
          </div>

          <div>
            <h2 className="text-bone font-serif text-lg mb-2">8. Security</h2>
            <p>
              We implement appropriate technical and organizational security measures, including HTTPS encryption (SSL certificates), to protect personal data against unauthorized access, loss, or alteration.
            </p>
          </div>

          <div>
            <h2 className="text-bone font-serif text-lg mb-2">9. Cookies & Tracking Technologies</h2>
            <p>
              This website utilizes technical cookies necessary for core functionality (such as cart management and session persistence). We do not employ profiling or advertising tracking cookies without prior user consent.
            </p>
          </div>

          <div>
            <h2 className="text-bone font-serif text-lg mb-2">10. Contact Information</h2>
            <p>
              For any questions regarding this Privacy Policy or data processing practices, please contact us at <a href="mailto:info@alkeontimelessdesign.com" className="text-bone underline underline-offset-4 hover:text-sand transition-colors">info@alkeontimelessdesign.com</a>.
            </p>
          </div>
        </section>

        <div className="pt-8 border-t border-bone/10">
          <Link to="/" className="label text-xs tracking-widest text-stone hover:text-bone transition-colors uppercase">
            &larr; Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;